import React from "react";
import AddToCartBTN from "../../../../../User/Home/Components/Homepage/UI-item,viewAll,BtmSheet/AddToCartBTN";
import defaultImg from "../../../../../img/LOGO.webp";
const Card = ({ item, hideBTN }) => {
  const { pID, sp, finalSp, qty, pName, mrp, free, free_item, productImg } =
    item;

  return (
    <div
      key={pID}
      className="card flex-row align-items-center card-bottom border-0"
    >
      <div className="card-image">
        <img
          src={
            item?.productImg
              ? item?.productImg
              : item?.imageURL
              ? item?.imageURL
              : defaultImg
          }
          loading="lazy"
          alt="product"
          width="auto"
          height="100%"
        />
      </div>
      <div className="card-body p-0">
        <h3>{pName}</h3>
        <h5>122 ML</h5>
      </div>
      <div
        className="d-flex align-items-center"
        style={{ whiteSpace: "nowrap" }}
      >
        <h5 className="h5price">
          <strong>₹{sp}</strong>
        </h5>
      </div>
      {hideBTN ? null : (
        <AddToCartBTN
          item={{
            pID,
            sp,
            newProductName: pName,
          }}
        />
      )}
    </div>
  );
};

export default Card;
